import $ from 'jquery';
import 'tooltipster';
import { useState, useEffect } from "react";
import packageChannelsTooltip from "../../modules/package-channels-tooltip";
import { tv } from "../../lib/api/api";

const ChannelDescription = ({channel_id}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        const elem = document.querySelector(`.js-package-channels-tooltip-${channel_id}`);
        if ('init' in elem.dataset) {
            $(`.js-package-channels-tooltip-${channel_id}`).tooltipster('destroy');
            $(`.js-package-channels-tooltip-${channel_id}`).removeAttr('data-init');
        }
        tv.channel(channel_id)
            .then((res) => {
                setName(res.name);
                const index = Math.min(res.description.indexOf('\r\n'), res.description.indexOf('.'));
                setDescription(res.description.slice(0, index === -1 ? Math.max(res.description.indexOf('\r\n'), res.description.indexOf('.')) + 1 : index + 1));
            })
            .catch((err) => {
                console.log(err);
            });
    }, [channel_id]);

    useEffect(() => {
        if (name.trim() !== '') {
            packageChannelsTooltip(`.js-package-channels-tooltip-${channel_id}`);
            const elem = document.querySelector(`.js-package-channels-tooltip-${channel_id}`);
            elem.dataset.init = 'tooltip';
        }
    }, [name]);

    return (
        <>
            <div className="package-channels__tooltip" id={"tooltip-channel-" + channel_id}>
                <div className="package-channels__tooltip-title">{name}</div>
                <div className="package-channels__tooltip-description">{description}</div>
            </div>
        </>
    );
};

export default ChannelDescription;
